import React from "react";

function Checkbox({ checkboxName, text}) {

  return (
    <div className="checkbox-wrapper">
      <input type="checkbox" id={checkboxName}/>
      <label className="check-img" htmlFor={checkboxName}/>
      <label htmlFor={checkboxName}>{text}</label>
    </div>
  );
}

export default Checkbox;
